
import { Badge } from "@/components/ui/badge";
import { Play, TrendingUp, CheckCircle } from "lucide-react";

export const VideoSection = () => {
  return (
    <section id="video-section" className="py-12 md:py-16 lg:py-[60px]">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 dark:text-white mb-4">
            Veja como funciona na prática
          </h2>
          <p className="text-base md:text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto mb-8 px-4">
            Demonstração completa de como configurar e ativar seus programas de cashback e indicações em menos de 10 minutos
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="relative aspect-video rounded-xl overflow-hidden shadow-2xl bg-gray-100 dark:bg-gray-800">
            <iframe 
              src="https://player.vimeo.com/video/123456789?h=abcd1234&badge=0&autopause=0&player_id=0&app_id=58479" 
              className="absolute inset-0 w-full h-full" 
              frameBorder="0" 
              allow="autoplay; fullscreen; picture-in-picture" 
              allowFullScreen 
              title="Demonstração Conversion Bonus"
            />
          </div>
          
          <div className="text-center mt-6 md:mt-8">
            <div className="flex flex-wrap justify-center gap-3 md:gap-4 mb-6 px-4">
              <Badge variant="outline" className="text-brand-teal border-brand-teal px-3 md:px-4 py-2 text-xs md:text-sm">
                <Play className="w-3 h-3 md:w-4 md:h-4 mr-2" />
                Configuração em 10 minutos
              </Badge>
              <Badge variant="outline" className="text-brand-coral border-brand-coral px-3 md:px-4 py-2 text-xs md:text-sm">
                <TrendingUp className="w-3 h-3 md:w-4 md:h-4 mr-2" />
                Resultados em 24h
              </Badge>
              <Badge variant="outline" className="text-brand-teal border-brand-teal px-3 md:px-4 py-2 text-xs md:text-sm">
                <CheckCircle className="w-3 h-3 md:w-4 md:h-4 mr-2" />
                Sem conhecimento técnico
              </Badge>
            </div>
            
            <p className="text-sm md:text-base text-gray-600 dark:text-gray-400 max-w-2xl mx-auto px-4">
              Assista à demonstração completa e descubra como implementar programas de fidelização que realmente funcionam para seu e-commerce.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
